
export class EventsUpdateTagGroup {
    hasGetNewListOfGroup: boolean;
}
